<div *ngIf="chart" class="card-with-shadow bg-white p-2">
  <div [chart]="chart" class=""></div>
</div>
